import { IClient } from "src/app/models/authentication/client";
import { IToken } from "src/app/models/authentication/token";
import { ConfigApp } from "src/app/utils/configApp";
import { Account } from 'src/app/models/authentication/account';
import { UserAccountInfo } from "src/app/models/user-account/account-data";
import { IWealthTokenModel } from "src/app/models/wealth/wealth_token.model";
import { IUserManagers, UserProfile } from "src/app/models/user-account/user-data";
import { UserNotification, UserSettings } from "src/app/models/authentication/userSettings";
import { LinkedAccountData } from "src/app/models/standby/linked-account";

export default interface AuthState {
  client: IClient | null;
  notifications: any[];
  tokens: IToken | null
  isLogged: boolean;
  error: Error | null;
  apiKey: string | null;
  tenant: string | null;
  settings: UserSettings;
  accountType: string | null;
  clientAccounts: UserAccountInfo[];
  clientAccountSelected: UserAccountInfo | null;
  linkedAccounts: LinkedAccountData[];
  wealth: boolean;
  wealthLink: IWealthTokenModel | null;
  managers: IUserManagers[] | null;
}

export const initialState: AuthState = {
  client: null,
  tokens: null,
  isLogged: false,
  error: null,
  apiKey: null,
  tenant: null,
  settings: new UserSettings('', false, false, false, false, false, new UserNotification(false, false,
    false, false, false)),
  accountType: null,
  clientAccounts: [],
  notifications: [],
  clientAccountSelected: null,
  wealth: false,
  wealthLink: null,
  managers: null,
  linkedAccounts: [],
}
